import { gsap, ScrollTrigger } from "@/composeables/gsap"

function createZoomAnimation(section) {
    const qs = gsap.utils.selector(section);
    const media = qs(".media");

    gsap.set(media, {
        willChange: 'transform',
        transformOrigin: 'top'
    })

    const scaleMedia = gsap.fromTo(
        media,
        { scale: 1.2 },
        { scale: 1 }
    );

    const timeline = gsap
        .timeline()
        .addLabel("start")
        .add([scaleMedia])
        .addLabel("end")

    const trigger = ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "top top",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });

}

function createParallaxAnimation(section) {
    const qs = gsap.utils.selector(section);
    const media = qs(".media img");

    const direction = 1;
    const percent = 30;
    const scale = 1.6;

    gsap.set(media, {
        willChange: 'transform'
    })

    const tween = gsap.fromTo(
        media,
        {
            y: (1 * direction * percent) + '%',
            scale: scale,
        },
        {
            y: (-1 * direction * percent) + '%',
            scale: scale,
            ease: "none",
        }
    )

    const timeline = gsap
        .timeline()
        .addLabel("start")
        .add(tween)
        .addLabel("end")

    ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        animation: timeline,
        scrub: true,
    });
}

export const init = () => {
    gsap.utils
        .toArray(['.section-media[data-variant="zoom"]', '.section-text-on-video'])
        // .toArray('.section-media')
        .forEach(createZoomAnimation);

    // gsap.utils
    //     .toArray('.section-text-on-image[data-variant="parallax"]')
    //     .forEach(createParallaxAnimation);
};

export default init;
